<mat-stepper
  #stepper
  class="flyout-content__stepper stepper"
  [class]="stepperCssClass()"
  linear
  orientation="vertical"
  (selectedIndexChange)="moveToStep($event)"
>
  <mat-step
    [completed]="firstStepCompleted()"
    [label]="firstStepTitle()"
    [editable]="firstStepEditable()"
    color="accent"
  >
    @if (firstStepCompleted() && !isFirstStep()) {
      <ng-container *ngTemplateOutlet="firstStepResultTemplate()" />
    } @else {
      <ng-container *ngTemplateOutlet="firstStepTemplate()" />
    }
  </mat-step>

  <mat-step [completed]="secondStepCompleted()" [label]="secondStepTitle()" color="accent">
    <ng-template matStepContent>
      <ng-container *ngTemplateOutlet="secondStepTemplate()" />
    </ng-template>
  </mat-step>

  <ng-template matStepperIcon="edit">
    <mat-icon>done</mat-icon>
  </ng-template>
</mat-stepper>

@if (isFinalStep()) {
  <mp-two-step-edit-actions
    [actionsDisabled]="!isSubmittable()"
    [autoRepeatEnabled]="autoRepeatEnabled()"
    (save)="save.emit()"
    (saveAndContinue)="saveAndContinue.emit()"
    (cancelEdit)="cancelEdit.emit()"
  />
}
